"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._outsmartly_override = _outsmartly_override;
exports._outsmartly_mark_return = _outsmartly_mark_return;
exports._outsmartly_mark_attr = _outsmartly_mark_attr;
exports._outsmartly_mark_child = _outsmartly_mark_child;

var React = _interopRequireWildcard(require("react"));

var _env = require("./env.js");

var _applyOverrides = require("./applyOverrides.js");

var _htmlSafeJSONStringify = require("./htmlSafeJSONStringify.js");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _outsmartly_override(args, scope) {
  try {
    if (!_env._outsmartly_enabled) {
      return args;
    }

    return (0, _applyOverrides.applyOverrides)(args, scope);
  } catch (e) {
    if (e instanceof Promise) {
      throw e;
    }

    console.error(e);
    return args;
  }
}

function _outsmartly_mark_return(scope, args, branchSelections, value) {
  if (!_env._outsmartly_emit_markers) {
    return value;
  }

  var argsScriptElement = React.createElement('script', {
    type: 'application/json',
    'data-outsmartly-component': scope,
    dangerouslySetInnerHTML: {
      __html: (0, _htmlSafeJSONStringify.htmlSafeJSONStringify)({
        args: args,
        branchSelections: branchSelections
      })
    }
  });
  return React.createElement(React.Fragment, null, argsScriptElement, _outsmartly_mark_child(scope, '0', value));
}

function _outsmartly_mark_attr(scope, sliceIds, value) {
  if (!_env._outsmartly_emit_markers) {
    return value;
  }

  return React.cloneElement(value, {
    'data-outsmartly-marker': "".concat(scope, ":").concat(sliceIds)
  });
}

function _outsmartly_mark_child(scope, sliceIds, value) {
  if (!_env._outsmartly_emit_markers) {
    return value;
  }

  var d = "".concat(scope, ":").concat(sliceIds);
  return React.createElement(React.Fragment, null, React.createElement('outsmartly-marker', {
    d: d
  }, value));
}